import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import ExampleComponent from '../ExampleComponent'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <ExampleComponent />
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
